import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import { Functions } from "../../../helpers/Functions.jsx";

const ActivosModal = ({ show, onClose, onSave, showCreate, title, categoriasEvaluacion, initDataActivos }) => {
    const { handleSubmit: handleSubmitModal, reset: resetModal, register: registerModal, setValue : setValueModal, getValues: getValuesModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [detalles, setDetalles] = useState(CONFIGURACIONES.INIT.ARRAY);

    const selectCategorias = useMemo(() => {
        return categoriasEvaluacion.filter(categoria => categoria.aplicado_a == CONFIGURACIONES.INIT.LIST_CATEGORIAS.ACTIVO_FIJO);
    }, [categoriasEvaluacion]);

    useEffect(() => {
        resetModal();
        if (initDataActivos !== CONFIGURACIONES.INIT.NULL) {
            setValueModal('totalActivos', initDataActivos.total);
            setDetalles(initDataActivos.detalles);
        }
    }, [initDataActivos]);

    useMemo(() => {
        let total = 0;
        detalles.forEach((item) => {
            total += parseFloat(item.total);
        });
        setValueModal('totalActivos', isNaN(total) ? '' : total.toFixed(2));
        return isNaN(total) ? '' : total.toFixed(2); 
    }, [detalles]);

    const onAgregarItem = (form) => {
        const {totalActivos, ...form2} = form;
        form2['id'] = Functions().generarNumeroUnico(detalles);
        // detalles.push(form);
        setDetalles([...detalles, form2]);
        resetModal();
    };
    
    const saveData = () => {
        let data = {
            'total': getValuesModal('totalActivos'),
            'detalles': detalles
        }

        onSave(data);
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onAgregarItem)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                                <div className="form-group">
                                    <label htmlFor="detalle" className="control-label col-form-label">Detalle <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="detalle"
                                        id="detalle"
                                        {...registerModal("detalle", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.detalle && errorsModal.detalle.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="cantidad" className="control-label col-form-label">Cantidad <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="cantidad"
                                        id="cantidad"
                                        {...registerModal("cantidad", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                let cantidad = e.target.value;
                                                let precio = getValuesModal('precio');
                                                let total = parseFloat(cantidad || 0) * parseFloat(precio || 0);
                                                setValueModal('total', isNaN(total) ? '' : total.toFixed(2));
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.cantidad && errorsModal.cantidad.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="precio" className="control-label col-form-label">Precio <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="precio"
                                        id="precio"
                                        {...registerModal("precio", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => { 
                                                let precio = e.target.value;
                                                let cantidad = getValuesModal('cantidad');
                                                let total = parseFloat(cantidad || 0) * parseFloat(precio || 0);
                                                setValueModal('total', isNaN(total) ? '' : total.toFixed(2), {shouldValidate: true});
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.precio && errorsModal.precio.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="total" className="control-label col-form-label">Total <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="total"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        id="total"
                                        {...registerModal("total", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.total && errorsModal.total.message }</small>
                                </div>
                            </div>
                            
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="categoria" className="control-label col-form-label">Categoría <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("categoria", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                        })} className="form-control" id="categoria"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            selectCategorias.map((el, index) => (
                                                <option key={index} value={el.nombre}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.categoria && errorsModal.categoria.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-sm-12 col-md-2">
                                <WaveButton className="btn btn-sm btn-outline-info wave-effect" type="submit">
                                    <i className="mdi mdi-plus"></i> Agregar
                                </WaveButton>
                            </div>
                        </div>

                        {/* 📊 Tabla */}
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                            <table className="table table-sm table-hover compact-table align-middle text-wrap">
                                <thead className="bg-success text-white">
                                <tr>
                                    <th>Detalle</th>
                                    <th>Cantidad</th>
                                    <th>Precio</th>
                                    <th>Total</th>
                                    <th>Categoría</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {detalles.length > 0 ? (
                                    detalles.map((item) => (
                                        <tr key={item.id}>
                                            <td className="text-wrap">{item.detalle}</td>
                                            <td className="text-wrap">{item.cantidad}</td>
                                            <td className="text-wrap">{item.precio}</td>
                                            <td className="text-wrap">{item.total}</td>
                                            <td className="text-wrap">{item.categoria}</td>
                                            <td>
                                                <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => {
                                                    setDetalles(detalles.filter((detalle) => detalle.id !== item.id));
                                                }}>
                                                    <i className="mdi mdi-delete"></i>
                                                </WaveButton>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center text-muted">
                                            <span className="text-danger">No se encontraron resultados</span>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-2">
                                <div className="form-group">
                                    <label htmlFor="totalActivos" className="control-label col-form-label">Total <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="totalActivos"
                                        id="totalActivos"
                                        readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                        {...registerModal("totalActivos", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.totalActivos && errorsModal.totalActivos.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="button" className="btn btn-sm btn-success waves-effect" onClick={saveData}>
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default ActivosModal;
